export { fileDict, type fileDictType } from './constants/files.dicts';
export { type FormType } from './types/form-types';

export { MAIN_WAITING_INITIAL_PAYMENT } from './constants/bank-texts';

export { default } from './euras-bank';
